import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyOthersFailed() {
  return <Section bg="white" data-id="element-228">
      <div className="max-w-3xl mx-auto bg-[#FFF8F0] rounded-3xl p-8 md:p-10 border-2 border-[#F59E0B]/20 shadow-lg" data-id="element-229">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-[#422006]" data-id="element-230">
          Por qué lo que has intentado no funciona
        </h2>

        <ul className="space-y-6" data-id="element-231">
          <li className="flex items-start gap-4" data-id="element-232">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-233" />
            <p className="text-[#78350F] text-lg" data-id="element-234">
              <strong data-id="element-235">Los meal plans semanales</strong> te piden que cocines
              todo en un solo día, algo imposible cuando el domingo es tu único
              día de descanso.
            </p>
          </li>
          <li className="flex items-start gap-4" data-id="element-236">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-237" />
            <p className="text-[#78350F] text-lg" data-id="element-238">
              <strong data-id="element-239">Intentar improvisar</strong> cada noche desde cero te deja
              sin energía para compartir con tus hijos.
            </p>
          </li>
          <li className="flex items-start gap-4" data-id="element-240">
            <XCircle className="text-[#EA580C] shrink-0 mt-1" size={24} data-id="element-241" />
            <p className="text-[#78350F] text-lg" data-id="element-242">
              <strong data-id="element-243">Recalentar la misma comida</strong> sin variarla le quita
              frescura y te hace sentir que comes “sobras”.
            </p>
          </li>
        </ul>
      </div>
    </Section>;
}